import { AxiosError, isAxiosError } from "axios";

export const getErrorResponse = <T>(error: unknown): T | undefined => {
  if (isAxiosError(error)) {
    const axiosError = error as AxiosError<T>;
    if (axiosError.response) {
      return axiosError.response.data;
    }
    if (error.request) {
      console.log("No response received:", error.request);
    } else {
      console.log("Request setup error:", error.message);
    }
  } else {
    console.error("Error occurred:", (error as Error).message);
  }
};
